import React from "react";
import Header from "../../Components/Header";
import AprmMapping from "./AprmMapping";
import ClientrmMapping from "./ClientrmMapping";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";

function RmMapping() {
  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content">
        <div className="rm-mapping">
          <ul
            className="nav nav-tabs-mapping filter-tabs"
            id="knowledgeTab"
            role="tablist"
          >
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="module-tab"
                data-toggle="tab"
                data-target="#module-tab-pane"
                type="button"
                role="tab"
                aria-controls="module-tab-pane"
                aria-selected="true"
              >
                AP RM
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="video-tab"
                data-toggle="tab"
                data-target="#video-tab-pane"
                type="button"
                role="tab"
                aria-controls="video-tab-pane"
                aria-selected="false"
              >
                Client RM
              </button>
            </li>
          </ul>
          <div
            className="tab-content refer-tab-content"
            id="knowledgeTabContent"
          >
            <div
              className="tab-pane fade show active"
              id="module-tab-pane"
              role="tabpanel"
              aria-labelledby="module-tab"
              tabIndex={0}
            >
              <AprmMapping />
            </div>
            <div
              className="tab-pane fade show"
              id="video-tab-pane"
              role="tabpanel"
              aria-labelledby="video-tab"
              tabIndex={1}
            >
              <ClientrmMapping />
            </div>
          </div>
        </div>
      </main>
    </>
  );
}
export default RmMapping;
